import { createContext } from 'react';

interface ModalStackContextType {
  registerModal: (id: string, closeHandler: () => void) => void;
  unregisterModal: (id: string) => void;
  closeTopModal: () => boolean;
  isTopModal: (id: string) => boolean;
}

export const ModalStackContext = createContext<ModalStackContextType | null>(
  null
);
